import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { Link } from 'react-router-dom';
import {
    withStyles, Typography, Button, IconButton,
} from '@material-ui/core';

import { EditIcon } from '../../../common/icons';

import urls from '../../../app/urls';

const styles = theme => ({
    root: {
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    header: {
        marginRight: theme.spacing(2),
    },
    item: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
        height: 36,
        borderRadius: 20,
    },
    editButton: {
        height: 36,
    },
    caption: {
        marginTop: theme.spacing(1),
        height: '1rem',
    },
});

class SkillNavigation extends React.Component {
    state = {
        info: '',
    }

    showInfo = info => () => {
        this.setState({ info });
    }

    hideInfo = () => {
        this.setState({ info: '' });
    }

    render() {
        const {
            classes, translate, studentId, selectedSkills, currentSkillNr, disabled,
        } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.buttons}>
                    <Typography variant="button" color="primary" className={classes.header}>
                        {`${translate('studentPlan.selectedSkills')}:`}
                    </Typography>
                    {selectedSkills.map((skill, i) => (
                        <Button
                            component={Link}
                            to={`${urls.inside.student.home}/${studentId}/${urls.inside.student.parts.plan}/${i}`}
                            key={skill.id}
                            className={classes.item}
                            color="primary"
                            variant={currentSkillNr === i ? 'contained' : 'outlined'}
                            onMouseEnter={this.showInfo(skill.module ? skill.module.name : '')}
                            onMouseLeave={this.hideInfo}
                        >
                            {i + 1}
                        </Button>
                    ))}
                    {!disabled && (
                        <IconButton
                            component={Link}
                            to={`${urls.inside.student.home}/${studentId}/${urls.inside.student.parts.skills}`}
                            className={classes.editButton}
                            onMouseEnter={this.showInfo(translate('studentPlan.chooseSkills'))}
                            onMouseLeave={this.hideInfo}
                        >
                            <EditIcon color="primary" />
                        </IconButton>
                    )}
                </div>
                <Typography color="primary" variant="caption" align="center" noWrap className={classes.caption} display="block">
                    {this.state.info}
                </Typography>
            </div>
        );
    }
}

SkillNavigation.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    studentId: PropTypes.string.isRequired,
    selectedSkills: PropTypes.array.isRequired,
    currentSkillNr: PropTypes.number.isRequired,
    disabled: PropTypes.bool,
};

SkillNavigation.defaultProps = {
    disabled: false,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(SkillNavigation));
